import { CustomerId } from '@tivio/sdk-react'


const envCustomer = process.env.REACT_APP_CUSTOMER as 'joj' | 'oktagon' | 'tivio' | 'mall' | 'garaz' | 'dvtv' | 'starmax' | 'stargaze'

const customerMap = {
    'joj': CustomerId.JOJ,
    'oktagon': CustomerId.OKTAGON,
    'tivio': CustomerId.MALL,
    'mall': CustomerId.MALL,
    'garaz': CustomerId.GARAZ,
    'dvtv': CustomerId.DVTV,
    'starmax': CustomerId.STARMAX,
    'stargaze': CustomerId.STARGAZE,
}

export const ENV = {
    COMMIT: process.env.REACT_APP_COMMIT as string,
    CUSTOMER: customerMap[envCustomer ?? 'tivio'],
    PLATFORM: process.env.REACT_APP_PLATFORM as 'webos' | 'tizen',
    BUILD_MODE: process.env.NODE_ENV,
    IS_DEBUG: process.env.REACT_APP_DEBUG === 'true',
}

export const IS_WEBOS = ENV.PLATFORM === 'webos'
export const IS_TIZEN = ENV.PLATFORM === 'tizen'

console.info(`@tivio: Tivio TV app info:
    commit: ${ENV.COMMIT}
    customer: ${ENV.CUSTOMER}
    platform: ${ENV.PLATFORM}
    build mode: ${ENV.BUILD_MODE}
    debug: ${ENV.IS_DEBUG}
`)
